import React, { type FC } from 'react'

export const createFormatter =
    <T,>(Renderer: FC<T>, props: T): FC =>
    (...chunks) =>
        <Renderer {...props}>{chunks}</Renderer>

export const boldFormatter = createFormatter((props) => <b {...props} />, {})
